const getSlottedElement = (el: HTMLElement, selector: string): HTMLElement => {
    let element = el.querySelector(selector) as HTMLElement;
    if (element && element.nodeName === 'SLOT') {
        const assignedElements = (element as HTMLSlotElement).assignedElements();
        if (assignedElements.length) {
            element = assignedElements[0] as HTMLElement;
        }
    }
    return element;
};

/**
 * Returns true if el named slot is not empty
 */
const hasNamedSlotNodes = (el: HTMLElement, slotName: string): boolean => {
    return !!el.querySelector(`[slot="${slotName}"]`);
};

const uniqueId = (prefix = ''): string => {
    const hashValue = prefix.split('').reduce((acc, char) => {
        return (acc << 5) - acc + char.charCodeAt(0);
    }, 0);
    const base36String = Math.abs(hashValue).toString(36);
    const sixCharId = base36String.slice(0, 6);
    const paddedId = sixCharId.padStart(6, '0');
    return `${prefix}-${paddedId}`;
};

const uniqueElementId = (element: HTMLElement): string => {
    return uniqueId(element.tagName.toLowerCase());
};

export const DomUtility = {
    getSlottedElement,
    hasNamedSlotNodes,
    uniqueId,
    uniqueElementId,
};

export { SvgUtility } from './icons';
